import React from 'react';
import { TabProps } from './tabTypes';

const Tab: React.FC<TabProps> = ({ children, active, onClick }) => (
    <div className={`tab ${active ? 'active' : ''}`} onClick={onClick}>
        {children}
    </div>
);

export default Tab;
